// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"675":"extra","945":"dashboard"}[chunkId] + "-legacy." + {"675":"e8478564","945":"9d675914"}[chunkId] + ".js";
};